import { createContext } from '@chakra-ui/react-utils';
import type { SystemStyleObject } from '@chakra-ui/system';

import type { ContainerPart } from './types';

export type ContainerStyles = Partial<Record<ContainerPart, SystemStyleObject>>;

const [ContainerStylesProvider, useContainerStyles] =
  createContext<ContainerStyles>({
    name: 'ContainerStylesContext',
    strict: true,
    errorMessage:
      'useContainerStyles: `context` is undefined. Seems you forgot to wrap all menu components within `<Container />`',
  });

export { ContainerStylesProvider, useContainerStyles };
